module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/valoresIcon.23899a31.svg";